export default "https://cdn-static.gokick.com/assets/0205635f2685a00e1fdcb9112c4ac213a84703ca/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";